/**
 * SubscribeGameIncidentsQueryInfo defines properties and callbacks for the subscribe of gameIncidents endpoint of the sports data client.
 * @class SportDataGatewayQueryInfo
 */
var SubscribeGameIncidentsQueryInfo = /** @class */ (function () {
    /* istanbul ignore next */
    function SubscribeGameIncidentsQueryInfo(eventIds, onMessageHandler, onErrorHandler, incidentTypes) {
        this.onMessageHandler = onMessageHandler;
        this.onErrorHandler = onErrorHandler;
        this.eventIds = eventIds;
        this.incidentTypes = incidentTypes;
    }
    return SubscribeGameIncidentsQueryInfo;
}());
export { SubscribeGameIncidentsQueryInfo };
//# sourceMappingURL=SubscribeGameIncidentsQueryInfo.js.map